<template>
  <!-- 系统首页 -->
  <div>
    <pl v-show="this.off == false" />
    <el-row>
      <el-col>
        <Annglobal v-show="this.off == true" />
        <div class="f_logo" @click="clearTips"><Header /></div>
        <div class="f_footer" @click="clearTips">
          <Footers
            @switchs="switchs"
            @setAtter="getAtter"
            @map_change="in_map"
          />
        </div>
        <div v-show="!map_change">
        <div class="f_left" @click="clearTips" ><Left /></div>
        <div class="f_right" @click="clearTips"><Right /></div>
        </div>
        <div class="f_out">
          <span
            style="
              color: #3ef89c;
              margin-right: 10px;
              font-family: Source Han Sans CN, Source Han Sans CN-Bold;
              font-size: 16px;
              font-weight: 700;
              height: 22px;
              line-height: 24px;
            "
            >{{ value_one }}</span
          >
          <span
            style="
              color: #3ef89c;
              font-family: Source Han Sans CN, Source Han Sans CN-Bold;
              font-weight: 700;
              font-size: 16px;
              height: 22px;
              line-height: 24px;
              cursor: pointer;
              margin-left: 5px;
              text-decoration: underline;
            "
            @click="out"
            >{{ value_two }}</span
          >
        </div>
        <!-- 图例 -->
        <div class="f_cont_cutline">
          <div v-if="name1 == '土地资源'"><load /></div>
          <div v-if="name1 == '农业规划'"><agricultural /></div>
          <div v-if="name1 == '作物分布'"><crop /></div>
          <div v-if="name1 == '设施农业'"><facility /></div>
          <div v-if="name1 == '农机具服务'"><tool /></div>
        </div>
        <div class="f_records" v-if="!hideRecord">
          CopyRight @ 2021 中国共产党平罗县委员会网络安全和信息化委员会办公室
          备案号：<span @click="toNew()" style="cursor:pointer">宁ICP备2021002403号-1</span>
          <span @click="toRecord()" style="cursor: pointer"
        >宁公网安备 64022102000127号-1</span
      >
          技术支持：<span
            @click="click_west"
            style="cursor: pointer"
            >西部电子商务股份有限公司</span
          >
        </div>
        <div
          class="map_change"
          v-if="map_change == true"
          @click="click_change()"
        >
          {{ flagTxt }}
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
// 地图图层
import Annglobal from "./annglobal/annglobal.vue";
import pl from "./PLDigitalVillage.vue";
import Header from "./header/header.vue";
import Footers from "./footers.vue";
import Left from "./leftAside/left.vue";
import Right from "./rightAside/right.vue";
// 图例
import load from "./cutline/load_source.vue";
import agricultural from "./cutline/agricultural_planning.vue";
import crop from "./cutline/crop_distribution.vue";
import facility from "./cutline/facility_agriculture.vue";
import tool from "./cutline/agricultural_tools.vue";
export default {
  name: "pLogin",
  components: {
    Header,
    Footers,
    Left,
    Right,
    pl,
    Annglobal,
    load,
    agricultural,
    crop,
    facility,
    tool,
  },
  data() {
    return {
      off: "",
      value_one: "您好，管理员",
      value_two: "退出登录",
      name1: "",
      map_change: "",
      flag: true,
      flagTxt: "三维",
      hideRecord: false,
    };
  },
  methods: {
    getAtter: function (msg) {
      this.name1 = msg;
      console.log(this.name1)
    },
    out: function () {
      this.$confirm("确认是否退出", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$message({
            type: "success",
            message: "已退出",
          });
          // 清除token
          $.removeCookie("token");
          this.$router.push("/");
          //刷新页面
          location.reload();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    switchs(flag) {
      this.off = flag;
    },
    in_map(res) {
      this.map_change = res;
      console.log(this.map_change)
    },
    click_change() {
      if (this.flag) {
        plMap.mapViewer.type = true;
        this.flag = false;
        plMap.ZoomFull();
        this.flagTxt = "二维";
      } else {
        plMap.mapViewer.type = false;
        this.flag = true;
        plMap.ZoomFull();
        this.flagTxt = "三维";
      }
    },
    click_west() {
      window.open("https://beian.miit.gov.cn");
    },
    clearTips() {
      plMap.plClearPopupInfo();
    },
    toNew(){
      window.open('https://beian.miit.gov.cn/#/Integrated/index')
    },
    toRecord(){
      window.open("http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=64022102000127");
    }
  },
  mounted: function () {
    //检测是否已经登录
    this.hideRecord = !!(typeof $ !== 'undefined' && $.cookie && $.cookie('token'));
  },
};
</script>

<style scoped lang="less">
body {
  padding: 0;
}
li {
  list-style: none;
}
a {
  text-decoration: rgb(62, 248, 156);
}
.f_img_border {
  width: 1.125rem;
  height: 1.125rem;
  margin-right: 0.3125rem;
}
.f_img_border img,
.f_font_border img,
.nongye_img img {
  width: inherit;
  height: inherit;
}
.map_change {
  position: absolute;
  color: #fff;
  padding: 2px 10px;
  border-radius: 5px;
  top: 12px;
  cursor: pointer;
  right: 13%;
  text-align: center;
}
.f_font_border {
  width: 5.625rem;
  height: 1.225rem;
  display: inline-block;
}
.font_PI {
  color: rgb(62, 248, 156);
}
.f_cont_cutline {
  color: #333;
  font-weight: bold;
  font-size: 12px;
}
.nongye_img {
  width: 2rem;
  height: 2rem;
  margin: auto;
}
.font_PI_one {
  font-size: 1rem;
}
.font_PI_two {
  font-size: 8px;
}
.font_PI_four {
  font-size: 1.2em;
}
.font_PI_three {
  font-size: 0.75rem;
}
.f_logo {
  top: 35px;
  width: 55rem;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  height: 4rem;
  z-index: 2;
}
.f_records {
  width: 100%;
  line-height: 35px;
  height: 35px;
  text-align: center;
  background: #00574a;
  font-size: 12px;
  position: fixed;
  bottom: 0px;
  color: #fff;
  left: 0px;
  z-index: 2;
}
* {
  padding: 0;
  margin: 0;
}
.f_left,
.f_right {
  top: 35px;
  height:calc(100vh - 35px);
}
.f_left,
.f_right {
  position: absolute;
  width: 21%;
  z-index: 2;
}
.f_left {
  left: 0.625rem;
}
.f_right {
  right: 0.625rem;
}
.f_footer {
  position: fixed;
  bottom: 40px;
  left: 50%;
  transform: translate(-50%, -20%);
  z-index: 2;
}
.f_left_pingluozonglan,
.f_left_shuzipingluo,
.f_left_shuzizhengwu,
.f_right_shengtaiyiju,
.f_right_shuzinongye,
.f_right_yingyongshifan {
  padding: 0.5rem;
  margin: 4px 0;
  background: url("../assets/images/border.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.f_pingluo_top {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.475rem;
  border-bottom: 1px solid rgba(74, 252, 209, 0.6);

  position: relative;
}
.f_pingluo_font table {
  width: 100%;
}
.f_pingluo_font table tr {
  line-height: 1.5625rem;
}
.f_first,
.f_two,
.f_three {
  margin: 0.625rem 0;
}
.chidren_logo {
  background-image: linear-gradient(
    to right,
    rgb(121, 226, 154),
    rgba(62, 248, 156, 0)
  );
  border-left: 4px solid rgb(62, 248, 156);
}
.echarts_border {
  height: 36rem;
  overflow: auto;
}
.first_font_cont,
.second_font_cont {
  display: flex;
  justify-content: space-around;
  padding: 0.5625rem 0 0.65rem 0;
  line-height: 23px;
}
.second_font_cont {
  padding-top: 1.25rem;
}
.first_font {
  text-align: left;
  padding-left: 0.625rem;
  color: #fff;
}
.f_shuzizhengwu_cont {
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
}
.f_shengtaiyiju_cont {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
}
.f_xuanchaunpian,
.f_qixiang {
  margin-top: 0.5rem;
}
.f_xuanchuan_cont,
.f_qixiang_cont {
  width: 1.875rem;
  height: 1.6875rem;
  border: 0.0625rem solid #000;
  margin: 10px 0 0 0;
}
.f_shuzinongye_cont,
.f_yingyongshifan_cont {
  margin: 0.625rem 0 0 0;
}
.f_yingyongshifan_cont {
  line-height: 1.5625rem;
  color: #fff;
}
.agriculture_logo {
  width: 4rem;
  height: 2rem;
  background-size: cover;
  background-repeat: no-repeat;
  background: url("../assets/images/agriculture.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.f_yingyongshifan_cont a {
  color: rgb(62, 248, 156);
}
.f_shuzinongye_cont td {
  text-align: center;
}
.f_shuzinongye_cont tr {
  line-height: 2rem;
}
.f_pingluo_font td {
  color: #fff;
}
.f_out {
  position: absolute;
  top: 12px;
  right: 30px;
  color: #fff;
  z-index: 2;
  &::after {
    content: "";
    display: block;
    clear: both;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/plHome.vue